import * as React from "react";
import { testSpecRelations } from "src/business/specification";
import { PageUrl } from "src/routes/PageUrl";

import {
  ManagementSpecCommonList,
  ManagementSpecCommonListStore,
} from "../ManagementSpecCommon";
import { ObjectsManager } from "../ObjectsManager";

const beforeDelete = async (ids: string[], names: Record<string, string>) => {
  // Предварительная проверка, нет ли спецификаций, которые используются
  // eslint-disable-next-line no-restricted-syntax
  for (const id of ids) {
    // eslint-disable-next-line no-await-in-loop
    const res = await testSpecRelations(id, "values");
    if (res.hasRelations) {
      const name = names[id] ?? id;
      throw Error(
        `Нельзя удалить спецификацию "${name}", пока она используется.`,
      );
    }
  }
};

const pageStore = new ManagementSpecCommonListStore({
  specType: "values",
  beforeDelete,
});

export const ManagementValueSpecs: React.FC = () => (
  <ObjectsManager tab="valueSpecs">
    <ManagementSpecCommonList
      cardUrl={PageUrl.managementValueSpecCard}
      pageStore={pageStore}
    />
  </ObjectsManager>
);
